import { Icon } from 'components/shared/Atoms';
import {
  Avatar,
  Button,
  Dropdown,
  Flex,
  MenuProps,
  Space,
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useLanguage } from 'hooks/Language/useLanguage';
import { useState } from 'react';
import agbColors from 'constants/Colors/agbColors';

const LocalDropdown: React.FC<{
  items: MenuProps['items'];
  handleMenuClick?: MenuProps['onClick'];
  isCircle?: boolean;
  image?: string | false | undefined;
  firstName?: string | false | undefined;
  lastName?: string | false | undefined;
}> = ({
  items,
  handleMenuClick,
  isCircle = false,
  image,
  firstName,
  lastName,
}) => {
  const { translate } = useLanguage();
  const [imageLoadError, setImageLoadError] = useState(false);

  const getInitials = ({
    firstName = '',
    lastName = '',
  }: {
    firstName: string;
    lastName: string;
  }) => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <Dropdown
      menu={menuProps}
      overlayClassName="local-dropdown"
      trigger={['click']}
    >
      {!isCircle ? (
        <Button type="primary" size="large">
          <Flex justify="space-between" align="center" gap="small">
            <Icon name="transfer" />
            <Space>
              {translate('Transfer money')}
              <DownOutlined />
            </Space>
          </Flex>
        </Button>
      ) : (
        <Button
          type="primary"
          size="large"
          shape="circle"
          style={{ background: 'none' }}
          icon={
            <Avatar
              src={!imageLoadError ? image : null}
              onError={() => {
                setImageLoadError(true);
                return false;
              }}
              style={{
                width: '42px',
                height: '42px',
                backgroundColor:
                  !image || imageLoadError
                    ? agbColors.DarkGoldenrodColor
                    : 'transparent',
                color:
                  !image || imageLoadError ? '#ffffff' : undefined,
              }}
            >
              {(!image || imageLoadError) &&
                getInitials({
                  firstName: firstName ? firstName : '',
                  lastName: lastName ? lastName : '',
                })}
            </Avatar>
          }
        />
      )}
    </Dropdown>
  );
};

export default LocalDropdown;
